import type { ReactNode } from 'react'
import { Card } from '@/components/ui/card'
import { cn } from '@/utils/cn'

/** Investigation-detail card section: icon badge + title/hint header, optional
 *  trailing `meta`, and content. */
export function DetailSection({
  icon,
  title,
  hint,
  meta,
  children,
  className,
}: {
  icon?: ReactNode
  title: string
  hint?: string
  meta?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <Card asChild className={cn('p-4', className)}>
      <section>
        <header className="mb-4 flex items-start justify-between gap-3">
          <div className="flex min-w-0 items-center gap-2">
            {icon && (
              <span className="flex size-7 shrink-0 items-center justify-center rounded-lg border border-border bg-muted text-muted-foreground">
                {icon}
              </span>
            )}
            <div>
              <h2 className="text-sm font-semibold text-foreground">{title}</h2>
              {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
            </div>
          </div>
          {meta}
        </header>
        {children}
      </section>
    </Card>
  )
}
